import { css } from '@emotion/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { Button } from 'components/Button';
import { FormControlError } from 'components/FormControlError';
import { Input } from 'components/Input';
import { Label } from 'components/Label';
import { useMutation } from 'urql';

import { useAuth } from 'context/useAuth';
import { useNavigate } from 'react-router-dom';
import { theme } from 'styles/theme';
import { QUERY_USER_LOGIN } from 'queries/queries-auth';
import { useStore } from 'hooks/useStore';
import authStore from 'modern/authStore';

export const SignInForm = () => {
	const { errorStore } = useStore();

	const navigate = useNavigate();

	if (authStore.isAuthenticated) {
		navigate('/booker/requests');
	}

	// useEffect(() => {
	// 	if (isLogged) {
	// 		navigate('/booker/requests');
	// 	}
	// }, [isLogged, navigate]);

	const [{ fetching }, executeLogin] = useMutation(QUERY_USER_LOGIN);

	const {
		handleSubmit,
		register,
		formState: { errors },
	} = useForm();

	const onSubmit = (data: any) => {
		errorStore.clear();

		executeLogin({
			input: {
				username: data.email,
				password: data.password,
			},
		}).then((result) => {
			console.log(result);

			if (result.error) {
				errorStore.add({ type: 'Špatné přihlašovací údaje.', message: 'Zkuste to znovu.' });
			} else {
				authStore.setToken(result.data.login.access_token);
			}
		});
	};

	return (
		<div
			css={css`
				width: 320px;
				padding-bottom: 40px;
			`}
		>
			<div
				css={css`
					text-align: center;
					padding-top: 40px;
				`}
			>
				<svg
					width="28px"
					height="32px"
					viewBox="0 0 28 32"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
				>
					<g id="Logo" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g id="logo" transform="translate(-3.000000, 0.000000)">
							<g id="Group-Copy" transform="translate(3.000000, 0.000000)">
								<path
									d="M4,0 L16.3333333,0 C21.3038961,-9.13077564e-16 25.3333333,4.02943725 25.3333333,9 C25.3333333,13.9705627 21.3038961,18 16.3333333,18 L0,18 L0,18 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z"
									id="Rectangle-Copy-2"
									fill="#6778ff"
								></path>
								<path
									d="M0,14.6666667 L19.3333333,14.6666667 C24.1198012,14.6666667 28,18.5468655 28,23.3333333 C28,28.1198012 24.1198012,32 19.3333333,32 L4,32 C1.790861,32 2.705415e-16,30.209139 0,28 L0,14.6666667 L0,14.6666667 Z"
									id="Rectangle-Copy"
									fill="#5162EC"
								></path>
							</g>
						</g>
					</g>
				</svg>
			</div>
			<div
				css={css`
					font-size: 32px;
					color: ${theme.color.text['400']};
					text-align: center;
					line-height: 40px;
					margin-bottom: 12px;
					margin-top: 32px;
				`}
			>
				Přihlášení
			</div>
			<div
				css={css`
					font-size: 16px;
					color: ${theme.color.text['300']};
					text-align: center;
					line-height: 24px;
					margin-bottom: 32px;
				`}
			>
				Zadejte své přihlašovací údaje.
			</div>

			<form onSubmit={handleSubmit(onSubmit)}>
				<Label vertical htmlFor="email">
					E-mail
				</Label>
				<Input
					placeholder="@"
					{...register('email', {
						required: 'Zadejte email.',
						pattern: {
							value: /\S+@\S+\.\S+/,
							message: 'Neplatný email.',
						},
					})}
					error={errors.email}
				/>

				{errors.email && <FormControlError>{errors.email.message}</FormControlError>}

				<div
					css={css`
						height: 16px;
					`}
				></div>

				<Label vertical htmlFor="password">
					Heslo
				</Label>
				<Input
					placeholder="Zadejte heslo..."
					{...register('password', { required: 'Zadejte heslo.' })}
					error={errors.password}
					isPassword
				/>

				{errors.password && <FormControlError>{errors.password.message}</FormControlError>}

				<div
					css={css`
						height: 32px;
					`}
				></div>

				<Button type="submit" block large isProcessing={fetching}>
					Přihlásit se
				</Button>
			</form>
		</div>
	);
};
